import { render } from "./quiz-v1-multiple-choice.vue?vue&type=template&id=4937943b&scoped=true"
import script from "./quiz-v1-multiple-choice.vue?vue&type=script&lang=js"
export * from "./quiz-v1-multiple-choice.vue?vue&type=script&lang=js"

import "./quiz-v1-multiple-choice.vue?vue&type=style&index=0&id=4937943b&lang=sass&scoped=true"

import exportComponent from "../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4937943b"]])

export default __exports__